import Skeleton from '~/components/Loading/Skeleton';

/** Generic known-shape page skeleton for pending soft navigations. */
export function WorkspacePageSkeleton() {
  return (
    <div className="flex h-full min-h-full w-full flex-col gap-6 p-6" aria-busy="true" aria-label="Loading">
      <div className="space-y-2">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <div className="space-y-3">
        <Skeleton className="h-5 w-36" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-14 w-3/4" />
      </div>
    </div>
  );
}
